/** Allowlist return paths for embedded module save/back (avoid open redirects). */
export function sanitizeSdReturnTo(raw: string | null): string | null {
  if (!raw || typeof raw !== "string") {
    return null;
  }
  let decoded: string;
  try {
    decoded = decodeURIComponent(raw.trim());
  } catch {
    return null;
  }
  if (!decoded.startsWith("/sd/")) {
    return null;
  }
  if (decoded.includes("://") || decoded.includes("..")) {
    return null;
  }
  return decoded.split("#")[0] || null;
}
